import classNames from './GoogleEmptyClassesModal.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';
import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

interface GoogleClassesResultModalProps {
  show: boolean;
  hasFilteredClasses: boolean;
  onSubmit: () => void;
}

const GoogleEmptyClassesModal = ({
  show,
  hasFilteredClasses,
  onSubmit,
}: GoogleClassesResultModalProps) => {
  const { t } = useTranslation();

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classes(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                <h2>{hasFilteredClasses ? t('classesImported') : t('noClassToImport')}</h2>
                <span className={classNames.description}>
                  {hasFilteredClasses ? '' : t('noClassToImportDescription')}{' '}
                </span>
                <TheButton
                  className={classNames.closeBtn}
                  text={t('done')}
                  shouldRecolor={false}
                  emitOnClick={onSubmit}
                />
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default GoogleEmptyClassesModal;
